import { render, staticRenderFns } from "./BirthSelect.vue?vue&type=template&id=05f2e222"
import script from "./BirthSelect.vue?vue&type=script&lang=js"
export * from "./BirthSelect.vue?vue&type=script&lang=js"
import style0 from "./BirthSelect.vue?vue&type=style&index=0&id=05f2e222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports